const getBase64FileType = (fileUrl: string) => {
  if (fileUrl.startsWith('data:image') || fileUrl.startsWith('blob:')) return 'image'
  if (fileUrl.startsWith('data:video') || fileUrl.startsWith('blob:')) return 'video'
  if (fileUrl.startsWith('data:application/pdf') || fileUrl.endsWith('.pdf')) return 'pdf'
  return 'unknown'
}

export const MediaViewer = ({
  media,
  classname = 'w-100 h-100',
}: {
  media: string
  classname?: string
}) => {
  if (!media) return <p></p>

  const fileType = getBase64FileType(media)

  return (
    <div className={`${classname}`}>
      {fileType === 'image' && (
        <img
          src={media}
          alt='Media'
          className='w-100 h-100 border border-gray-400'
          style={{objectFit: 'contain'}}
        />
      )}
      {fileType === 'video' && (
        <video
          controls
          className='w-100 h-100 border border-gray-400'
          style={{objectFit: 'contain'}}
        >
          <source src={media} />
          Your browser does not support the video tag.
        </video>
      )}
      {fileType === 'pdf' && (
        <iframe src={media} width='100%' height='500px' title='PDF File'></iframe>
      )}
      {fileType === 'unknown' && (
        <img
          src={`data:image/jpeg;base64,${media}`}
          alt='Media'
          className='w-100 h-100 border border-gray-400'
          style={{objectFit: 'contain'}}
        />
      )}
    </div>
  )
}
